import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HowToPlayComponent } from './how-to-play/how-to-play.component';
import { HomeComponent } from './home/home.component';
import { FaqComponent } from './faq/faq.component';
import { TermsComponent } from './terms/terms.component';


const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', component: HomeComponent },
  { path: 'how-to-play', component: HowToPlayComponent },
  { path: 'faqs', component: FaqComponent },
  { path: 'terms-conditions', component: TermsComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
